







































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import './style.scss'
import { formatNumber, showConfirmButton } from '@/utils/helpers'
import ExportPDF from './ExportPDF/ExportPDF.vue'
import EditOrderDetail from '@/components/EditOrderDetail/index.vue'
import constants from '@/utils/constants'

library.add(faEdit);

@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    },
  },
  components: {
    ExportPDF,
    EditOrderDetail,
  },
})
export default class OrderDetail extends Vue {
  @Prop() detailButton!: any
  @Prop() item!: any
  @Prop() orderStatus!: any
  @Prop(String) detailOrderId!: String
  @Prop(Boolean) detailButtonShow!: Boolean
  @Prop(Function) hideOrderDetail!: Function
  @Prop(Function) handleClickCancelButton!: Function
  @Prop(Function) hideAll!: Function
  @Prop(Function) clickorderdatail!: Function
  @Prop(Function) handleNextStatus!: Function
  @Prop(Function) refundOrder!: Function
  @Prop(Function) showPosOrder!: Function
  @Prop(Function) handleUpdateOrderDetail!: Function
  @Prop() isAdmin!: boolean
  @Prop() isRunner!: boolean
  currentItem: Object = {}
  resItem: Object = {}
  amountUser: Object = {}
  amountAddress: Object = {}
  orderType: any = ''
  paymentDetails: any
  isPdfShow: boolean = false
  constants: any = constants
  showConfirmButton: any = showConfirmButton

  get formatPayDetails() {
    const payDetails = this.item.paymentDetails || {}
    if (this.item.paymentDetails.totalAmount) {
      if (
        this.item.paymentDetails.totalAmount.split('.')[
        this.item.paymentDetails.totalAmount.split('.').length - 1
          ] === '00'
      ) {
        for (let key in this.item.paymentDetails) {
          payDetails[key] = formatNumber(
            this.item.paymentDetails[key]
          )
        }
      }
    }
    return payDetails
  }

  triggerDownload(orderType, orderID) {
    ;(this.$refs as any).isDownloadPDF.download(orderType, orderID)
  }
}
